import { ifAuthenticated } from '@/router/before'

export const adminPages = [
  {
    path: '/admin/users-list',
    name: 'AdminUsersListRoute',
    meta: {
      icon: ['fas', 'user'],
      isDisplayInSidebar: true,
      group: 'Администрирование',
      displayName: 'Список пользователей',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "AdminUsersListRoute" */ '@/views/admin/AdminUsersListRoute.vue'
      ),
  },

  {
    path: '/admin/activity',
    name: 'ActivityRoute',
    meta: {
      icon: ['fa', 'tasks'],
      isDisplayInSidebar: true,
      group: 'Администрирование',
      displayName: 'Журнал активности',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ActivityRoute" */ '@/views/admin/ActivityRoute.vue'
      ),
  },
  {
    path: '/admin/logs',
    name: 'ServerLogsRoute',
    meta: {
      icon: ['fa', 'satellite-dish'],
      isDisplayInSidebar: true,
      group: 'Администрирование',
      displayName: 'Логи сервера',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ServerLogsRoute" */ '@/views/admin/ServerLogsRoute.vue'
      ),
  },
  {
    path: '/admin/sessions',
    name: 'SessionsRoute',
    meta: {
      icon: ['fa', 'binoculars'],
      isDisplayInSidebar: true,
      group: 'Администрирование',
      displayName: 'Активные сессии',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "SessionsRoute" */ '@/views/admin/SessionsRoute.vue'
      ),
  },
  {
    path: '/admin/history',
    name: 'HistoryRoute',
    meta: {
      icon: ['fa', 'history'],
      isDisplayInSidebar: true,
      group: 'Администрирование',
      displayName: 'История изменений',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "HistoryRoute" */ '@/views/admin/HistoryRoute.vue'
      ),
  },
  {
    path: '/admin/build',
    name: 'BuildInfoRoute',
    meta: {
      icon: ['fa', 'cog'],
      isDisplayInSidebar: true,
      group: 'Администрирование',
      displayName: 'Обслуживание системы',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "BuildInfoRoute" */ '@/views/admin/BuildInfoRoute.vue'
      ),
  },
  {
    path: '/admin/fake-auth',
    name: 'FakeAuthRoute',
    meta: {
      icon: ['fa', 'user-secret'],
      isDisplayInSidebar: true,
      group: 'Администрирование',
      displayName: 'Просмотр за другого пользователя',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "FakeAuthRoute" */ '@/views/admin/FakeAuthRoute.vue'
      ),
  },
]
